import { Plug } from "lucide-react";
import { Section, SectionHeading, Card } from "./service-revops-ui";
import { SectionCta } from "./service-revops-section-cta";
import { gohighlevelConfig as defaultConfig } from "./service-platform-config";
import type { PlatformConfig } from "./service-platform-config";

export function ServiceBuilds({
  config = defaultConfig,
}: {
  config?: PlatformConfig;
} = {}) {
  const builds = config.builds;
  const integrations = config.integrations;
  return (
    <Section>
      <SectionHeading
        eyebrow={config.buildsEyebrow}
        navy={config.buildsHeadlineNavy}
        blue={config.buildsHeadlineBlue}
        sub={config.buildsSub}
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {builds.map((b) => (
          <Card key={b.label} radius={18}>
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 rounded-[12px] flex items-center justify-center shrink-0"
                style={{ background: "#EDF7FF" }}
              >
                <b.icon className="w-5 h-5" style={{ color: "#0B7CF2" }} />
              </div>
              <span
                className="font-display font-bold"
                style={{
                  fontSize: "14.5px",
                  color: "#071E61",
                  letterSpacing: "-0.015em",
                }}
              >
                {b.label}
              </span>
            </div>
          </Card>
        ))}
      </div>

      {/* Integrations strip */}
      <div className="mt-10">
        <div className="flex items-center gap-2 mb-5 justify-center">
          <Plug className="w-4 h-4" style={{ color: "#0B7CF2" }} />
          <span
            className="font-sans font-bold uppercase"
            style={{
              fontSize: "12px",
              letterSpacing: "0.18em",
              color: "#082E67",
            }}
          >
            {config.buildsIntegrationsLabel}
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-2.5">
          {integrations.map((name) => (
            <span
              key={name}
              className="inline-flex items-center rounded-full px-4 py-2 font-sans text-[13px] font-semibold"
              style={{
                background: "#FFFFFF",
                border: "1px solid rgba(11,124,242,0.14)",
                color: "#082E67",
              }}
            >
              {name}
            </span>
          ))}
        </div>
      </div>
      <SectionCta
        variant="soft"
        copy={config.buildsCtaCopy}
        label={config.buildsCtaLabel}
      />
    </Section>
  );
}
